import Slider2 from './slider2';
import styles from '../styles/section2.module.scss';
import slider1 from '../img/slider-2/1.jpeg';
import slider2 from '../img/slider-2/2.jpg';
import slider3 from '../img/slider-2/3.jpg';
import slider4 from '../img/slider-2/4.jpg';
import slider5 from '../img/slider-2/5.jpeg';
import React from 'react';
const items = [{
    header: 'TERRENOS A PARTIR DE 400 m²',
    text: '¡No te pierdas el gran estilo de vida que ofrece Balvanera!',
    position: 3,
    altText: 'golf1',
    src: slider1,
  },

  {
    header: 'LOTES EXCLUSIVOS',
    text: 'Sé dueño de un exclusivo lote y disfruta las maravillas de vivir en Balvanera Palermo SOHO, Querétaro.',
    position: 2,
    altText: 'golf1',
    src: slider2,
  },

  {
    header: 'ACTIVIDADES EXCLUSIVAS',
    text: 'Disfruta con tu familia del Polo y Golf en Balvanera Palermo SOHO, Querétaro.',
    position: 3,
    altText: 'golf1',
    src: slider3,
  },

  {
    header: 'ELIGE TU LOTE',
    text: 'Balvanera Palermo SOHO está en Etapa 1. ¡Elige la ubicación de tu lote!',
    position: 4,
    altText: 'golf1',
    src: slider4,
  },

  {
    header: '¡VIVE EN QUERÉTARO!',
    text: 'Lotes y departamentos en una de las zonas más exclusivas de Querétaro en Balvanera Palermo SOHO.',
    position: 5,
    altText: 'golf1',
    src: slider5,
  },
];
const Section2 = (props) => {
  return ( <
    div className = {
      styles.section2 + ' p-md-5 py-5 px-2'
    } >
    <
    Slider2 items = {
      items
    }
    /> < /
    div >
  );
};
export default Section2;